// [TEAM/CORE]: This enum will became a problem whenever we will need to translate it
// Currently being used on the details of a virtual devices, mode row on Device details
export enum DeviceMode {
  Production = 'Production',
  Dev = 'Development',
}

export interface DeviceApplication {
  readonly id: string;
  readonly name: string;
  readonly version: string;
  readonly status: string;
  readonly size: number;
}
export interface DeviceBaseInfo {
  readonly androidVersion?: string;
  readonly deviceFamily?: string;
  readonly firmware?: string;
  readonly manufacturerPartNumber?: string;
  readonly mode?: DeviceMode;
  readonly serialNumber?: string;
}

export interface DeviceMetrics extends DeviceBaseInfo {
  readonly applications?: DeviceApplication[];
  readonly batteryUsage?: number;
  readonly bluetooth?: string;
  readonly bluetoothStatus: 'active' | 'inactive';
  readonly CPUUsage?: number;
  readonly dateOfReport?: string;
  readonly ethernet?: string;
  readonly ethernetStatus?: 'active' | 'inactive';
  readonly flashUsage?: number;
  readonly hasMobileNetwork?: boolean;
  readonly ICCD?: string;
  readonly id: string;
  readonly IMEI?: string;
  readonly IMSI?: string;
  readonly ipAddress?: string;
  readonly lastReportLocation?: { readonly lat: number; readonly lng: number };
  readonly lastSyncDate?: string;
  readonly mobileNetworkName?: string;
  readonly mobileNetworkStatus: 'active' | 'inactive';
  readonly mobileNetworkStrength?: 'EXCELLENT' | 'GOOD' | 'POOR' | undefined;
  readonly mobileNetworkType?: string;
  readonly RAMUsage?: number;
  readonly SIMCardName?: string;
  readonly SIMCardStatus: 'active' | 'inactive';
  readonly SSID?: string;
  readonly statusLAN: 'active' | 'inactive';
  readonly batteryCycles: string;
  readonly batteryHealth: string;
  readonly isScreenLocked?: boolean;
  readonly provider?: 'GPS';
  readonly accuracy?: string;
}
